module.exports = __webpack_public_path__ + "static/undraw_work_in_progress_uhmv-a11a87375224f91fa15b56433419c470.svg";